// Imports MUI Components
import { Box } from "@mui/material"

// Import Asset
import logo from "../../../../assets/logo.png"

// Import Atom
import Icon from "../../../../components/UI/atoms/icon/Icon"

const SplashScreen = ({ isOpen }) => {
  if (!isOpen) return null;

  // Styling
  const style = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "#FDF9F3",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  }

  return (
    <div>
      <Box
        sx={style}>

        <Icon
          src={logo}
          size="splash"/>

      </Box>
    </div>
  );
};

export default SplashScreen; 